import React from 'react';
import IconButton from '../icon-button';
import HorizontalStack from '../horizontal-stack';

const defaultActions = [];

function IconButtonGroup({ actions = defaultActions, gap = 'spacing-3-xs' }) {
  if (!actions.length) return null;

  return (
    <HorizontalStack gap={gap} verticalAlign="center">
      {actions.map((action) => {
        const {
          glyph,
          label,
          size,
          appearance,
          transparent,
          selected,
          disabled,
          onClick,
          onMouseDown,
        } = action;

        const handleClick = (e) => {
          e.stopPropagation();

          onClick();
        };

        return (
          <IconButton
            key={`icon-button-${label}-${glyph}`}
            glyph={glyph}
            label={label}
            size={size}
            appearance={appearance}
            transparent={transparent}
            selected={selected}
            disabled={disabled}
            onClick={handleClick}
            onMouseDown={onMouseDown}
          />
        );
      })}
    </HorizontalStack>
  );
}

export default IconButtonGroup;
